/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Tier {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return Tier.fixupPrototype; }

    static newInstance(model: Partial<Tier>): Tier {
        let obj = Object.assign(new Tier(), model);
        Tier.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Tier>): Tier {
        if (!model) return null;
        return Tier.newInstance(<Tier> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Tier) {
        if (!obj) return;

        models.Tier.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Tier): boolean {
        switch (obj.__type)
        {
            case "BillingRuleTier":
                Object.setPrototypeOf(obj, models.BillingRuleTier.prototype);
                break;
            case "CreateLineItemTier":
                Object.setPrototypeOf(obj, models.CreateLineItemTier.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof Tier)[] {
        return [
            models.BillingRuleTier,
            models.CreateLineItemTier,
        ];
    }

    fixupFields() {
        if (this.min === undefined) {
            this.min = 0;
        }
        if (this.max === undefined) {
            this.max = 0;
        }
    }

    /**
     * Minimum value of the tier
     */
    min: number;

    /**
     * Maximum value of the tier
     */
    max: number;

}
